import React from 'react';
import {
  Controller,
  useFormContext,
} from 'react-hook-form';
import Accordion from 'core/components/Accordion';
import {
  PatientForm,
} from 'pages/Dashboard/types/patient';
import AddressFields from 'pages/Dashboard/components/AddressFields';
import {
  validateAddressInfo,
} from 'utils/react-hook-form';

export default function PatientAddressInfo() {
  const { control, watch } = useFormContext<PatientForm>();
  const patientId = watch('patientId');

  return (
    <Accordion
      defaultExpanded
      header="Address"
      disableGutters
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-2 populate-form gap-form-row flex flex-col w-full' }}
    >
      <div className="flex w-full items-center gap-form-field">
        <Controller
          key={patientId}
          control={control}
          rules={{ validate: validateAddressInfo }}
          name="address"
          render={({ field }) => (
            <AddressFields {...field} />
          )}
        />
      </div>
    </Accordion>
  );
}
